import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export const APP_CALLBACK_PROTOCOL = 'com.ironforums.app:';
export const APP_LINKEDIN_CALLBACK = 'com.ironforums.app://linkedin/callback';

export function parseLinkedInCallback(rawUrl: string): {
  state: string;
  error: string | null;
  code: string | null;
} | null {
  let url: URL;
  try {
    url = new URL(rawUrl);
  } catch {
    return null;
  }
  if (
    url.protocol !== APP_CALLBACK_PROTOCOL
    || url.hostname !== 'linkedin'
    || url.pathname !== '/callback'
  ) {
    return null;
  }
  const state = url.searchParams.get('state') || '';
  if (!state) return null;
  return {
    state,
    error: url.searchParams.get('error'),
    code: url.searchParams.get('code'),
  };
}

/** Bounce the web OAuth callback into the installed app when there is no popup opener. */
export function linkedInAppCallbackUrl(params: {
  state: string;
  code?: string;
  error?: string;
}): string {
  const url = new URL(APP_LINKEDIN_CALLBACK);
  url.searchParams.set('state', params.state);
  if (params.code) url.searchParams.set('code', params.code);
  if (params.error) url.searchParams.set('error', params.error);
  return url.toString();
}

/** Hand the OAuth URL to Safari/Chrome. LinkedIn's in-app browser shows "Bummer". */
export async function openLinkedInInSystemBrowser(authorizationUrl: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url: authorizationUrl });
    return;
  }
  window.location.assign(authorizationUrl);
}

export async function closeLinkedInBrowser(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await Browser.close();
  } catch {
    // Already dismissed after the app-scheme bounce.
  }
}
